
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DelDialog from "./delete-dialog.vue";
import Pop from "../components/blue-pop.vue";
import {
  Param,
  ShowConfig,
  MutiChoiceOption,
  Choice2Option
} from "@/lib/model/exambuilder/exam-v2";

enum optionEnum {
  "年龄" = "17及以下,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61及以上",
  "学历" = "硕士及以上,本科,大专,高中,中专,初中及以下",
  "省份" = "安徽,北京,重庆,福建,甘肃,广东,广西,贵州,海南,河北,黑龙江,河南,香港,湖北,湖南,江苏,江西,吉林,辽宁,澳门,内蒙古,宁夏,青海,山东,上海,山西,陕西,四川,台湾,天津,新疆,西藏,云南,浙江,海外",
  "满意度" = "很不满意,不满意,一般,满意,很满意",
  "认同度" = "很不同意,不同意,一般,同意,很同意",
  "是否" = "是,否",
  "数字" = "1,2,3,4,5",
  "星期" = "星期一,星期二,星期三,星期四,星期五,星期六,星期日",
  "月份" = "1月,2月,3月,4月,5月,6月,7月,8月,9月,10月,11月,12月",
  "年份" = "1980,1981,1982,1983,1984,1985,1986,1987,1988,1989,1990,1991,1992,1993,1994,1995,1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026,2027,2028,2029,2030"
}
enum logoEnum {
  "string" = "&#xe64d",
  "phone" = "&#xe64f",
  "email" = "&#xe64e",
  "idcard" = "&#xe665",
  "date" = "&#xe662",
  "city" = "&#xe664",
  "school" = "&#xe64c",
  "major" = "&#xe64c",
  "choice" = "&#xe64c",
  "multiChoice" = "&#xe66a",
  "choice2" = "&#xe668",
  "multiChoice2" = "&#xe669",
  "birthCity" = "&#xe672;",
  "address" = "&#xe672;",
  "bmi" = "&#xe75b;",
  // "interviewTime" = "&#xe662",
  "file" = "&#xe666"
}

@Component({
  components: { DelDialog, Pop }
})
export default class RegidEdit extends Vue {
  @Prop({}) editParam!: Param; //当前字段
  @Prop({}) allParam!: Param[]; //全部字段
  defaultParam = new Param(); //记录一下初始数据
  defaultParamBeforeAdd = new Param(); //记录一下批量添加前的数据
  title = "";
  formData: Param = new Param();
  showAddChoice = false; //单选批量添加
  optionText = "";
  ifShowConfig = false; //是否条件显示
  showConfigParentIndex: any = ""; //父级题目index
  showConfigEq: any = []; //条件显示 单选 要命中的
  showMultiPic = false; //多选示例图
  choice2Model = new Choice2Option(); //二级单选 切换缓存
  muti2Model = new Choice2Option();
  lastType = ""; //切换时 前一个type
  showDaysLimit = false;
  defZmnTime = ["09:00", "18:00"];
  // timeList: any[] = [{ value: ["09:00", "18:00"] }]; //啄木鸟时间段

  isStoreTime(formData: any) {
    return formData.inputType === "interviewTime";
  }

  changeZmnTime(e: any, i: any) {
    const haveSame = this.formData.interviewTimeConfig.timesLimit.some(
      (d: any, n: number) => {
        return n !== i && d[0] === e[0] && d[1] === e[1];
      }
    );
    if (haveSame) {
      this.$message.warning("时间段不能重复");
      this.formData.interviewTimeConfig.timesLimit.splice(
        i,
        1,
        ["", ""] // this.defZmnTime
      );
      this.$forceUpdate();
      return;
    }
    const timeLong =
      new Date(String("2000-1-1 " + e[1])).getTime() -
      new Date(String("2000-1-1 " + e[0])).getTime();
    if (timeLong < 30 * 60 * 1000) {
      this.$message.warning("起止时间至少间隔30分钟");
      this.formData.interviewTimeConfig.timesLimit.splice(
        i,
        1,
        ["", ""] // this.defZmnTime
      );
      this.$forceUpdate();
      return;
    }
  }
  inZmnTime(e: any, i: number) {
    this.defZmnTime = e;
  }

  //一些业务原因 需要禁止编辑的字段
  get canNotEdit() {
    //默认的身份证号字段 不可编辑
    const res1 =
      this?.editParam?.inputType === "idcard" &&
      this?.editParam?.name === "身份证号";
    //其他业务
    // const res2 = true;

    return res1;
  }

  //单选校验
  optionPass(rule: any, value: any, callback: any) {
    if (value.join("").replace(/ /g, "") === "") {
      callback(new Error("请输入至少一个选项"));
    } else {
      // this.$refs.ruleForm.validateField('checkPass');
      callback();
    }
  }
  //条件显示
  rule2(rule: any, value: any, callback: any) {
    if (this.showConfigParentIndex) {
      callback();
    } else {
      callback(new Error(" "));
    }
  }
  //条件显示选项
  rule3(rule: any, value: any, callback: any) {
    if (this.showConfigEq.length > 0) {
      callback();
    } else {
      callback(new Error(" "));
    }
  }
  //多选
  rule4(rule: any, value: any, callback: any) {
    //至少一个选项
    const hasOne = value.find((d: MutiChoiceOption) => {
      return d.key !== "";
    });
    //有描述 选项不能为空
    const descOk = !value.find((d: MutiChoiceOption) => {
      return d.showDesc && d.desc && !d.key;
    });
    if (hasOne && descOk) {
      callback();
    } else {
      callback(new Error("请将选项内容和选项描述填写完整"));
    }
  }
  //二级单选 非严格模式 只需必填 填写时用
  rule5(rule: any, value: any, callback: any) {
    this.formData.choice2options.keyList1Chk = JSON.parse(
      JSON.stringify(this.formData.choice2options.keyList1)
    );
    this.formData.choice2options.keyList2Chk = JSON.parse(
      JSON.stringify(this.formData.choice2options.keyList2)
    );
    //全空
    const ft = this.formData.choice2options.keyList1.join("");
    const st = this.formData.choice2options.keyList2.reduce(
      (pre: any, cur: any, i: number) => {
        return pre + cur.join("");
      },
      ""
    );
    if (!ft && !st) {
      callback(new Error("请填写选项"));
      return;
    } else {
      callback();
    }
  }
  //二级单选 严格模式 父子必同时存在 提交时用
  checkChoice2Rule() {
    let res = true;
    //有父无子
    this.formData.choice2options.keyList1.forEach((d, i) => {
      if (d) {
        const allSonNone = this.formData.choice2options.keyList2[i].every(
          (m: string) => {
            return !m;
          }
        );
        if (allSonNone) {
          this.formData.choice2options.keyList2Chk[i].forEach(
            (m: string, n: number) => {
              this.formData.choice2options.keyList2Chk[i].splice(n, 1, "^*&%^");
            }
          );
          res = false;
        }
      }
    });
    //无父有子
    this.formData.choice2options.keyList2.forEach((d, i) => {
      const hasSon = d.some(op => {
        return op;
      });
      if (hasSon && !this.formData.choice2options.keyList1[i]) {
        this.formData.choice2options.keyList1Chk.splice(i, 1, "^*&%^");
        res = false;
      }
    });
    return res;
  }

  rules = {
    name: [{ required: true, message: "请输入字段名称", trigger: "change" }],
    inputType: [
      { required: true, message: "请选择格式类型", trigger: "change" }
    ],
    isRequired: [
      { required: true, message: "请选择是否必填", trigger: "change" }
    ],
    singleChoiceOptions: [
      { required: true, validator: this.optionPass, trigger: "change" }
    ],
    showConfigParentIndex: [{ validator: this.rule2, trigger: "change" }],
    showConfigEq: [{ validator: this.rule3, trigger: "blur" }],
    mutiChoiceOptions: [
      { required: true, validator: this.rule4, trigger: "blur" }
    ],
    //二级单选/二级多选
    choice2: [{ required: true, validator: this.rule5, trigger: "change" }],
    saveLater: [
      { required: true, message: "请选择展示位置", trigger: "change" }
    ]
  };
  //选项ID生成
  R() {
    return String((Math.random() * 10000000000).toFixed(0));
  }

  get showLogo() {
    return logoEnum[this.formData.inputType];
  }
  //条件展示 可作为父级的字段
  get showConfigList() {
    const t = this.allParam.filter((d: Param) => {
      return (
        ["choice", "multiChoice"].includes(d.inputType) &&
        d?.paramIndex !== this.editParam?.paramIndex
      );
    });
    return t;
  }
  //条件展示 已选父级
  get showConfigParent() {
    const t = this.showConfigList.find((d: Param) => {
      return d?.paramIndex == this.showConfigParentIndex;
    });
    return t;
  }
  //条件展示 选项
  get showConfigOptionList() {
    const t = this.showConfigList.find((d: Param) => {
      return d?.paramIndex === this.showConfigParent?.paramIndex;
    });
    //多选
    if (t?.inputType === "multiChoice") {
      const tt: any[] = [];
      t?.mutiChoiceOptions.forEach((m, n) => {
        tt.push(m.key);
      });
      return tt;
    }
    //单选
    if (t?.inputType === "choice") {
      return t?.singleChoiceOptions;
    } else {
      return [];
    }
  }

  created() {
    //编辑
    if (this.editParam) {
      this.formData = JSON.parse(JSON.stringify(this.editParam));
      this.defaultParam = JSON.parse(JSON.stringify(this.editParam)); //提交验证用
      //默认两个空选项
      this.formData.singleChoiceOptions = this.formData.singleChoiceOptions
        .length
        ? this.formData.singleChoiceOptions
        : ["", ""];
      //条件展示-回显
      this.ifShowConfig =
        this.formData.showConfigList?.[0]?.[0]?.matchParamIndex > 0;
      this.showConfigParentIndex = this.formData.showConfigList?.[0]?.[0]?.matchParamIndex;
      //找到父级字段 及 挂钩的选项
      const fa = this.allParam.find((d: Param) => {
        return d.paramIndex == this.showConfigParentIndex;
      });
      fa?.fIdList.forEach((d: any, i: number) => {
        this.formData.showConfigList.forEach((m: any, n: number) => {
          if (d == m[0].fId) {
            this.showConfigEq.push(
              fa.singleChoiceOptions[i] || fa.mutiChoiceOptions[i].key
            );
          }
        });
      });
      //over
      //二级单多选 缓存
      if (this.formData.inputType === "choice2") {
        this.choice2Model = this.formData.choice2options;
      } else if (this.formData.inputType === "multiChoice2") {
        this.muti2Model = this.formData.choice2options;
      }
      this.title = "编辑字段";
    } else {
      //新增
      this.setOptionDef();
      this.title = "新增字段";
      this.formData.inputType = "string"; //默认文本
      this.addOptionChoice2();
      this.choice2Model = JSON.parse(
        JSON.stringify(this.formData.choice2options)
      );
      this.muti2Model = JSON.parse(
        JSON.stringify(this.formData.choice2options)
      );
    }
    //复制一份二级单选原数据 校验用
    this.formData.choice2options.keyList2Chk = JSON.parse(
      JSON.stringify(this.formData.choice2options.keyList2)
    );
  }
  //选项初始化
  setOptionDef() {
    this.formData.singleChoiceOptions = ["", ""]; //单选默认两个
    this.formData.mutiChoiceOptions = [
      //多选默认三个
      new MutiChoiceOption(),
      new MutiChoiceOption(),
      new MutiChoiceOption()
    ];
  }
  //修改类型
  changeType(e: any) {
    this.setOptionDef();
    if (e === "date" && !this.formData.dateConfig) {
      this.$set(this.formData, "dateConfig", {
        dateFormate: null
      });
    }
    // 单多选
    if (e === "choice") {
      this.formData.fIdList = [this.R(), this.R()]; //单选项id
    } else if (e === "multiChoice") {
      this.formData.fIdList = [this.R(), this.R(), this.R()]; //多选项id
    } else {
      this.formData.fIdList = [];
    }
    //缓存二级单选
    if (this.lastType === "choice2") {
      this.choice2Model = JSON.parse(
        JSON.stringify(this.formData.choice2options)
      );
    } else if (this.lastType === "multiChoice2") {
      //二级多选
      this.muti2Model = JSON.parse(
        JSON.stringify(this.formData.choice2options)
      );
    }
    this.lastType = e; //修改前的类型

    //加载二级单选
    if (e === "choice2") {
      this.formData.choice2options = this.choice2Model;
    } else if (e === "multiChoice2") {
      //二级多选
      this.formData.choice2options = this.muti2Model;
    }
    //清校验
    this.$nextTick(() => {
      (this.$refs["form"] as any)?.clearValidate();
    });
  }
  //新增单选项
  addOption() {
    this.formData.singleChoiceOptions.push("");
    this.formData.fIdList.push(this.R());
  }
  //新增多选项
  addOptionMulti() {
    this.formData.mutiChoiceOptions.push(new MutiChoiceOption());
    this.formData.fIdList.push(this.R());
  }
  //删除单选项
  delOption(i: number) {
    if (this.formData.singleChoiceOptions.length <= 1) return false;
    this.formData.singleChoiceOptions.splice(i, 1);
    this.formData.fIdList.splice(i, 1);
  }
  //删除多选项
  delOptionMulti(i: number) {
    if (this.formData.mutiChoiceOptions.length <= 1) return false;
    this.formData.mutiChoiceOptions.splice(i, 1);
    this.formData.fIdList.splice(i, 1);
  }
  multiOnly(i: number) {
    this.formData.mutiChoiceOptions.forEach((d: any, j: number) => {
      if (i === j) {
        d.type = d.type === "unsetOthers" ? "" : "unsetOthers";
      } else {
        d.type = "";
      }
    });
  }
  //批量增加 单选
  addChoice() {
    this.defaultParamBeforeAdd = JSON.parse(JSON.stringify(this.formData)); //存一下批量开始前的数据
    this.optionText = this.formData.singleChoiceOptions
      .filter(function(s) {
        return s && s.trim();
      })
      .join("\n");
    this.showAddChoice = true;
  }
  addChoiceCancel() {
    this.showAddChoice = false;
  }
  //批量添加确认
  addChoiceOk() {
    // 去空
    this.formData.singleChoiceOptions = this.optionText
      .split("\n")
      .filter(function(s) {
        return s && s.trim();
      });
    //对比数量
    const newLength = this.formData.singleChoiceOptions.length;
    const oldLength = this.defaultParamBeforeAdd.singleChoiceOptions.length;
    if (newLength > oldLength) {
      //多了新增随机id
      const num = newLength - oldLength;
      for (let i = 0; i < num; i++) {
        this.formData.fIdList.push(this.R());
      }
    }
    if (newLength < oldLength) {
      //少了从后开始砍id
      const num = oldLength - newLength;
      for (let i = 0; i < num; i++) {
        this.formData.fIdList.pop();
      }
    }
    //全空置为默认值
    this.formData.singleChoiceOptions = this.formData.singleChoiceOptions.length
      ? this.formData.singleChoiceOptions
      : ["", ""];
    this.showAddChoice = false;
  }
  //添加一个预定值
  addSome(e: any) {
    if (e.target.className !== "btn") return;
    const t = optionEnum[e.target.innerText];
    this.optionText = t.split(",").join("\n");
  }
  //条件显示 选父
  changeParent(a: any, b: any) {
    this.showConfigEq = [];
    this.showConfigParentIndex = a;
    // (this.$refs.form as any)?.clearValidate("showConfigEq");
  }
  // 切换可选择日期
  showDaysLimitChange(value: boolean) {
    if (!value) {
      this.formData.dateConfig.daysLimit = 0;
    } else {
      this.formData.dateConfig.daysLimit = 5;
    }
  }
  //条件显示 选子
  changeOption(a: any, b: any) {
    (this.$refs.form as any)?.clearValidate("showConfigEq");
  }
  //条件显示 id映射string
  getOptionString(idList: string[]) {
    //
  }
  //二级单选 添加一级选项
  addOptionChoice2() {
    this.formData.choice2options.keyList1Chk.push("");
    this.formData.choice2options.keyList1.push("");
    this.formData.choice2options.keyList2Chk.push(["", ""]);
    this.formData.choice2options.keyList2.push(["", ""]);
  }
  //二级单选 添加二级选项
  addOptionChoice22(i: number) {
    this.formData.choice2options.keyList2Chk[i].push("");
    this.formData.choice2options.keyList2[i].push("");
  }
  // 二级单选 删除一级选项
  delOptionChoice2(i: number) {
    if (this.formData.choice2options.keyList1.length <= 1) return false;
    this.formData.choice2options.keyList1.splice(i, 1);
    this.formData.choice2options.keyList2.splice(i, 1);
  }
  // 二级单选 删除二级选项
  delOptionChoice22(i: number, n: number) {
    if (this.formData.choice2options.keyList2[i].length <= 1) return false;
    this.formData.choice2options.keyList2[i].splice(n, 1);
  }

  editCancel() {
    this.$emit("close", false);
  }
  editOk() {
    //处理条件展示
    if (this.ifShowConfig) {
      const t: any = [];
      if (this.showConfigParent?.inputType === "choice") {
        //单选 条件展示id挂靠
        this.showConfigEq.forEach((d: any, i: number) => {
          this.showConfigParent?.singleChoiceOptions.forEach(
            (m: any, n: number) => {
              if (m == d) {
                const config = new ShowConfig();
                config.matchParamId = this.showConfigParent?.paramId as number;
                config.matchParamIndex = this.showConfigParent
                  ?.paramIndex as number;
                config.matchType = "equal";
                config.matchValue = d;
                config.fId = this.showConfigParent?.fIdList[n] as string;
                t.push([config]);
              }
            }
          );
        });
        this.formData.showConfigList = t;
      }
      //多选 条件展示id挂靠
      if (this.showConfigParent?.inputType === "multiChoice") {
        this.showConfigEq.forEach((d: any, i: number) => {
          this.showConfigParent?.mutiChoiceOptions.forEach(
            (m: any, n: number) => {
              if (m.key == d) {
                const config = new ShowConfig();
                config.matchParamId = this.showConfigParent?.paramId as number;
                config.matchParamIndex = this.showConfigParent
                  ?.paramIndex as number;
                config.matchType = "contains";
                config.matchValue = d;
                config.fId = this.showConfigParent?.fIdList[n] as string;
                t.push([config]);
              }
            }
          );
        });
        this.formData.showConfigList = t;
      }
      console.log(t);

      //后续其他类型todo
    } else {
      //非条件展示
      this.formData.showConfigList = [];
    }
    //zmn时间段去空
    if (this.formData.inputType === "interviewTime") {
      this.formData.interviewTimeConfig.timesLimit = this.formData.interviewTimeConfig.timesLimit.filter(
        (d: any) => {
          return d[0] && d[1];
        }
      );
    }
    (this.$refs["form"] as any)?.validate((valid: any) => {
      // 二级选项校验
      let opRes = this.checkChoice2Rule();
      opRes = ["choice2", "multiChoice2"].includes(this.formData.inputType)
        ? opRes
        : true;
      //校验全通过
      if (valid && opRes) {
        //单选 option去空
        if (this.formData.inputType === "choice") {
          this.formData.singleChoiceOptions = this.formData.singleChoiceOptions.filter(
            d => d.replace(/ /g, "") && d.length
          );
        }
        //二级选择 option去空
        if (["choice2", "multiChoice2"].includes(this.formData.inputType)) {
          for (
            let i = 0;
            i < this.formData.choice2options.keyList1.length;
            i++
          ) {
            if (!this.formData.choice2options.keyList1[i]) {
              this.formData.choice2options.keyList1.splice(i, 1);
              this.formData.choice2options.keyList2.splice(i, 1);
              i--;
            }
          }
          this.formData.choice2options.keyList2.forEach((s, k) => {
            s = s.filter(op2 => {
              return op2.replace(/ /g, "") && op2.length;
            });
            this.formData.choice2options.keyList2.splice(k, 1, s);
          });
        }
        this.checkDelOptionSon();
        this.formData.name = this.formData.name.replace(/ /g, "");
        this.$emit("ok", this.formData, this.editParam);
      } else {
        //校验未通过
      }
    });
  }
  //处理可能存在的条件字段父级option被删
  checkDelOptionSon() {
    const a = this.defaultParam;
    const b = this.formData;
    const delIdList = [...a.fIdList]; //被删的选项idList
    a.fIdList.forEach(d => {
      b.fIdList.forEach(m => {
        if (d == m) {
          delIdList.splice(
            delIdList.findIndex(r => {
              return r == d;
            }),
            1
          );
        }
      });
    });
    //如有被删的选项 则取删掉可能挂载的子字段
    if (delIdList.length) {
      delIdList.forEach((d: string) => {
        this.allParam.forEach((m: Param) => {
          m.showConfigList.forEach((a: any) => {
            if (a[0].fId == d) {
              m.showConfigList.splice(
                m.showConfigList.findIndex(s => {
                  return s[0].fId == d;
                }),
                1
              );
            }
          });
        });
      });
    }
  }
}
